import Profile from "pages/LandingPages/Author/sections/Profile";
import routes from "routes";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Author page sections
import { Helmet } from "react-helmet-async";

import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";

export default function DenunciasPage() {
  return (
    <>
      <Helmet>
        <title>Denuncias Anónimas | Sindicato Panaderos San Juan</title>

        <meta
          name="description"
          content="Canal de denuncias confidencial para trabajadores panaderos. Informá irregularidades laborales, falta de aportes o condiciones de higiene de forma 100% anónima."
        />

        <meta
          name="keywords"
          content="denunciar trabajo en negro san juan, irregularidades laborales panaderos, denuncia anónima sindicato, defensa del trabajador panadero, condiciones de trabajo panaderías"
        />

        {/* Open Graph */}
        <meta property="og:title" content="Canal de Denuncias Laborales - 100% Anónimo" />
        <meta
          property="og:description"
          content="Protegemos tus derechos. Si conocés alguna irregularidad en tu lugar de trabajo, denuncialo de forma segura y confidencial aquí."
        />
        <meta
          property="og:image"
          content="https://www.pitcnt.uy/sites/default/files/styles/max_1300x1300/public/2024-07/PAN3.jpg?itok=9TGdDlLD"
        />
        <meta property="og:type" content="website" />

        <link rel="canonical" href="https://www.sindicatopanaderossanjuan.com.ar/denuncias" />
      </Helmet>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/afiliate",
          label: "Afiliate",
          color: "info",
        }}
        transparent
        light
      />
      <MKBox bgColor="white">
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.8),
                rgba(gradients.dark.state, 0.8)
              )}, url("https://www.pitcnt.uy/sites/default/files/styles/max_1300x1300/public/2024-07/PAN3.jpg?itok=9TGdDlLD")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />
        <Profile />

        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </MKBox>
    </>
  );
}
